import { string, object } from 'yup';
import { isValid } from 'date-fns/fp';
var validationSchema = object().shape({
  title: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.name ? string().required('Required') : string();
  }),
  firstname: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.name ? string().required('First name is required') : string();
  }),
  lastname: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.name ? string().required('Last name is required') : string();
  }),
  dob: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.dob ? string().test('isValidDate', 'Valid date of birth is required', function (value) {
      if (value && value.length < 10) return false;
      return isValid(new Date(value));
    }).required('Date of birth is required') : string();
  }),
  country: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.address ? string().required('Country is required') : string();
  }),
  address_line1: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.address ? string().min(5, 'Address should be at least 5 characters').required('Address is required') : string();
  }),
  city: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.address ? string().required('City is required') : string();
  }),
  postalcode: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.address ? string().required('Postal code is required') : string();
  }),
  state: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.address ? string().required('State is required') : string();
  }),
  identityDocument: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.identityDocument ? string().required('Identity document is required') : string();
  }),
  ssnLast4: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.ssnLast4 ? string().length(4).required('Last 4 digits of Social Security Number is required') : string();
  }),
  idNumber: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.idNumber ? string().required('ID Number is required') : string();
  }),
  email: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.email ? string().email().required('Email address is required') : string();
  }),
  phone: string().when('$requiredFields', function (requiredFields) {
    return requiredFields.phone ? string().length(10).required('US Phone Number is required') : string();
  })
});
export default validationSchema;